<template>
    <Loading
        :is-loading="data.isLoading"
        :text="data.processingText"
    />
</template>

<script setup>
import { computed, reactive } from 'vue';
import { postRedirectAccount } from '@/apis/redirect';
import { useRoute, useRouter } from 'vue-router';
import Loading from '@/components/Loading.vue';
import { postLogin } from '@/apis/login';
import routeName from '@/router/constant.js';
import { useStore } from 'vuex';
import { openPopup, openPopupCatchMessage } from '@/utils/vfmUtils';

const route = useRoute();
const router = useRouter();
const store = useStore();
const callBackParam = computed(() => route?.query?.callBackParam || store?.state?.permissions?.callBackParam);

const data = reactive({
    isLoading: true,
    processingText: '登入檢核中...',
    tokenString: '',
    callBackParam: callBackParam.value,
    callBackPath: 'otws',
});

const redirectAccount = () => {
    const request = {
        callBackParam: data.callBackParam,
        callBackPath: data.callBackPath,
    };
    postRedirectAccount(request).then(res => {
        if (res.data?.redirectUrl) {
            window.location.href = res.data.redirectUrl;
        } else {
            login();
        }
    }).catch(err => {
        openPopup(err.data.errorMessage, backPage);
        store.dispatch('permissions/setCallBackParam', '');
    });
};

const login = () => {
    const loginData = {
        id: '',
        myId: '',
        password: '',
        callBackParam: data.callBackParam,
    };

    postLogin(loginData).then((res) => {
        store.dispatch('permissions/setAuth', 'Y');
        store.dispatch('permissions/setUserInfo', res.data);
        store.dispatch('permissions/setCallBackParam', '');
        router.push({ name: routeName.HOME });
    }).catch(err => {
        openPopupCatchMessage(err);
    }).finally(() => {
        store.dispatch('permissions/setCallBackParam', '');
    });
};

const backPage = () => {
    router.replace({ name: routeName.NO_AUTH, query: null });
};

if (route?.query?.callBackParam) {
    store.dispatch('permissions/setCallBackParam', route?.query?.callBackParam);
    router.replace({ name: routeName.REDIRECT_ACCOUNT, query: null });
}

if (!callBackParam.value) {
    backPage();
} else {
    redirectAccount();
}

</script>
